/** Invoke notification callbacks immediately, without letting host failures interrupt chat. */
export function notifyHost<Args extends unknown[]>(
  callback: ((...args: Args) => void) | undefined,
  ...args: Args
): void {
  if (!callback) return;
  try {
    void Promise.resolve(callback(...args)).catch(() => {});
  } catch {
    // Notifications are best-effort, including async handlers supplied by hosts.
  }
}
